module.exports = __webpack_public_path__ + "h5/img/gashapon.de94f644.png";